module.exports = __webpack_public_path__ + "static/media/wine-glasses.9f4b4f3b.svg";